import type { ProductStatus } from "@adpilot/shared";
import { useQuery } from "@tanstack/react-query";
import { resolveProductListings } from "@/lib/product-listing-api";

interface ProductIdentity {
  sku: string;
  asin: string;
}

export function useProductPreviewStatuses(shopId: string, products: readonly ProductIdentity[]) {
  const identities = products.map(({ sku, asin }) => ({ sku, asin }));
  const query = useQuery({
    queryKey: ["product-listings", "preview-status", shopId, identities],
    queryFn: () =>
      resolveProductListings(
        shopId,
        identities.map(({ sku }) => sku),
      ),
    enabled: products.length > 0,
    staleTime: 30_000,
    retry: false,
  });
  const statuses = new Map<string, ProductStatus>();
  for (const result of query.data?.results ?? []) {
    if (
      (result.type === "resolved" || result.type === "inactive") &&
      identities.some(
        (product) => product.sku === result.listing.sku && product.asin === result.listing.asin,
      )
    ) {
      statuses.set(result.listing.sku, result.listing.productStatus);
    }
  }
  return statuses;
}
